import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import styles from './pendingEventCard.module.scss';
import EventParticipant from './EventParticipant/EventParticipant';
import EventTime from './EventTime';
import getEventHourRange from '../utils';
import { toggleEditModal } from '@/store/slices/components/calendarEvents/CalendarEventsSlice';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function PendingEventCard({ event, isFirst, trackCallback = null }) {
  const dispatch = useDispatch();
  if (!event) return null;
  const { contacts = [], agents = [], name, end, start, is_now, id } = event;
  const { data } = useSelector((state) => state.UserSlice);

  const timeRange = getEventHourRange(start, end, data?.user_language);
  const handleOpenCalendar = () => {
    dispatch(toggleEditModal({ id, date: start }));

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  return (
    <Box className={styles.pendingEventCard} onClick={handleOpenCalendar}>
      <Box className={styles.leftContentContainer}>
        <EventTime timeRange={timeRange} first={isFirst} isNow={is_now} />
        <Text className={styles.eventDescription}>{name}</Text>
      </Box>
      <Box className={styles.rightContentContainer}>
        <EventParticipant
          contacts={contacts}
          agents={agents}
          trackCallback={trackCallback}
        />
      </Box>
    </Box>
  );
}

export default PendingEventCard;
